import React from 'react';

export const AccessDenied: React.FunctionComponent<{isAccessDenied: boolean}> = (props) => {
  const { isAccessDenied } = props;
  if (isAccessDenied === false) {
    return <React.Fragment></React.Fragment>;
  }
  return (
    <article className="message is-danger">
      <div className="message-header">
        <p>Access Denied</p>
        <button className="delete" aria-label="delete"></button>
      </div>
      <div className="message-body">
        Access to this site is only possible with a valid Cellere account.
      </div>
    </article>
  );
};
